<template>
    <div class="swap-item-container">
        <img @click.stop="closeSwapModal" class="close-modal" :src="imageUrl('close-modal.png')"/>
        <div class="title replacement" v-if="!noProductsFoundMessage" :class="{hasProducts: substituteProducts.length}">
            Swipe to find a replacement Item
        </div>
        <div class="title fade-in" v-else>
             No Substitute Items Found
         </div>
        <transition name="fade">
            <slideshow
                    v-if="substituteProducts.length"
                    :images="substituteProducts.map(product => product.product_image_url)"
                    :zoomImages="substituteProducts.map(product => product.product_image_zoom_uri)"
                    :product="true"
                    :classes="{'swap-container': true}"
                    slideshowHeight="31vh">
            </slideshow>
        </transition>
        <transition name="fade">
            <div v-show="loading" class="loading-overlay">
                <loader></loader>
            </div>
        </transition>
        <div class="product-info" v-if="substituteProducts.length">
            <div class="product-brand" v-if="substituteProducts[index].product_brand">{{
                substituteProducts[index].product_brand }}
            </div>
            <div class="product-title">{{ substituteProducts[index].product_title }}</div>
            <div class="product-price">{{ substituteProducts[index].product_price | currency }}</div>
        </div>
        <div class="buttons-container">
            <div class="wtw-container small">
                <div @click.stop="swapProduct"
                     class="button pink full-width"
                     :class="{disabled: !substituteProducts.length || loading}"
                >
                    Swap it!
                </div>
                <div @click.stop="closeSwapModal" class="button outline full-width">Nevermind</div>
            </div>
        </div>
    </div>
</template>

<script>

    import Loader from '../common/loader.vue';
    import Mixins from "../../mixins/mixins";
    import DeactivateScroll from "../../mixins/deactivate-scroll";
    import Slideshow from "../common/slideshow.vue";
    import $ from 'webpack-zepto';

    export default {
        data() {
            return {
                substituteProducts: [],
                noProductsFoundMessage: false,
                loading: true,
                index: 0,
            }
        },
        components: {Loader, Slideshow},
        props: ['product'],
        mixins: [Mixins, DeactivateScroll],
        created() {
            this.$store.commit('menu/hideHeader');
            this.loading = true;
            this.$store.dispatch('products/fetchSubstituteProducts', {product: this.product})
                .then(response => {
                    if (response.length) {
                        this.noProductsFoundMessage = false;
                        this.substituteProducts = response;
                    } else {
                        this.substituteProducts = [];
                        this.noProductsFoundMessage = true;
                    }
                    this.loading = false;
                    console.log('substitute products:', response);
                })
                .catch(error => {
                    this.loading = false;
                    this.noProductsFoundMessage = true;
                    console.log(error);
                });

            this.$on('productSwapIndex', (index) => {
                this.index = index;
            })
        },
        beforeDestroy() {
            this.$store.commit('menu/resetHeader');
        },
        methods: {
            closeSwapModal() {
                this.$parent.$emit('closeSwapModal');
            },
            swapProduct() {
                this.loading = true;
                const substituteProduct = this.substituteProducts[this.index];
                
                this.$store.dispatch('generatedOutfits/swapProductFromOutfitCurrent', {
                    removeProduct: this.product,
                    swapProduct: substituteProduct,
                }).then(response => {
                    this.closeSwapModal();
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                });
            }
        },
        mounted() {
            setTimeout(
                () => {
                    $('.replacement').addClass('fade-in');
                }, 200);
        }
    }
</script>